import {Component, EventEmitter, Input, Output, inject} from '@angular/core';
import {DatePipe} from '@angular/common';
import {MatCard, MatCardActions, MatCardSubtitle, MatCardTitle} from '@angular/material/card';
import {MatButton} from '@angular/material/button';
import {HupSubscription} from '../../../data/models/subscription.model';
import {TranslationService} from '../../services/translation.service';
import {HouseNoPipe} from '../../pipes/houseno.pipe';

@Component({
  selector: 'app-subscription-card',
  templateUrl: './subscription-card.component.html',
  styleUrls: ['./subscription-card.component.css'],
  imports: [
    MatCard,
    MatCardTitle,
    MatCardSubtitle,
    MatCardActions,
    MatButton,
    DatePipe,
    HouseNoPipe
  ],
  standalone: true
})
export class SubscriptionCardComponent {
  protected translationService = inject(TranslationService);

  @Input() subscription: HupSubscription;
  /** Beschriftung des Aktionsbuttons – der Aufrufer liefert den übersetzten Text. */
  @Input() actionLabel: string = '';
  /** Klick auf den Aktionsbutton. Gibt das Abo der Karte mit, damit der Aufrufer weiß, welches gemeint ist. */
  @Output() action = new EventEmitter<HupSubscription>();
}
